<template>
    <div>
        <div v-if="loaded">
            <BasePage>

                <template v-slot:top-header>
                    <PageHeader />
                </template>

                <template v-slot:menu>
                    <SiteLogo :actionable="true" />
                    <MenuBar />
                </template>

                <template v-slot:page-body>
                    <router-view />
                </template>

            </BasePage>
        </div>
        <div class="loader" v-else>
            {{$t('generic.loading')}}...
            <div class="loading-item" v-loading="!loaded"> </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import BasePage from './BasePage.vue'
    import PageHeader from '@/layout/PageHeader.vue'
    import SiteLogo from '@/layout/SiteLogo.vue'
    import MenuBar from '@/layout/MenuBar.vue'

    import { useUserStore } from '@/stores/userStore';

    export default defineComponent({
        components: {
            BasePage,
            PageHeader,
            SiteLogo,
            MenuBar,
        },

        data() {
            return {
                loaded: false,
                userStrore: useUserStore(),
                userName: '',
            };
        },
        mounted() {
            this.init();
        },

        methods: {
            async init() {
                this.loaded = false;

                try { 
                    this.userName = this.userStrore.userName;
                }
                catch (error) {
                    this.loaded = false;
                    console.error(error);
                }

                this.loaded = true;
            }
        },
    })
</script>

<style scoped>
    .loader {
        margin-top: 100px;
    }
    .loading-item {
        margin-top: 30px;
    }
</style>